// External libraries
import gql from 'graphql-tag';
import {
  CART_AMOUNTS_FRAGMENT,
  CART_ITEMS_FRAGMENT,
  CART_OVERCAPTURE_FRAGMENT,
  CART_SUBSCRIPTION_FRAGMENT,
  SHIPPING_METHODS_FRAGMENT,
} from '@/lib/graphql';

export const CHECKOUT_SESSION_DATA_QUERY = gql`
  query CheckoutSessionDataQuery($token: String!) {
    checkoutSession(token: $token) {
      allowedCardIssuers

      cart {
        soldoutUrl
        showSoldoutPage
        ...CartAmounts

        ...CartItems

        ...CartOvercapture

        ...SubscriptionDetails

        billingAddress {
          city
          country
          line1
          line2
          postalCode
          state
          formattedFullAddress
        }

        cancelUrl {
          href
        }

        description

        email {
          stringValue
        }

        intent

        noteToBuyer

        payer {
          name {
            familyName
            givenName
          }
        }

        formattedPhoneNumber(shouldValidate: true, useInternationalFormat: true)
        phoneNumber(shouldValidate: true, stripDialingCode: true)

        shippingAddress {
          city
          country
          firstName
          isStoreAddress
          lastName
          line1
          line2
          postalCode
          state
          formattedFullAddress
        }

        ...ShippingMethods
      }

      checkoutSessionType

      merchant {
        country
        merchantId
        name
      }
    }
  }

  ${CART_OVERCAPTURE_FRAGMENT}
  ${CART_AMOUNTS_FRAGMENT}
  ${CART_ITEMS_FRAGMENT}
  ${CART_SUBSCRIPTION_FRAGMENT}
  ${SHIPPING_METHODS_FRAGMENT}
`;
